<template>
  <div>
    <div class="l-bg-white">
      <form @submit.prevent="update"
            @keydown="clearError($event)"
            autocomplete="no"
      >
        <div class="row my-4">
          <div class="col-3 pr-1">
            <div class="select-wrap">
              <label>First name</label>
              <input v-model="mover.first_name"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="first_name" />
          </div>
          <div class="col-3 px-1">
            <div class="select-wrap">
              <label>Last name</label>
              <input v-model="mover.last_name"
                     type="text"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="last_name" />
          </div>
          <div class="col-3 px-1">
            <div class="select-wrap">
              <label>Email</label>
              <input v-model="mover.email"
                     type="email"
                     class="form-control"
              />
            </div>
            <error-field :errors="errors" field="email" />
          </div>
          <div class="col-3 pl-1">
            <div class="select-wrap">
              <label>Phone</label>
              <input v-model="mover.phone"
                     type="text"
                     class="form-control"
                     @keydown="maskPhone($event)"
                     placeholder="Enter Phone"
                     maxlength="14"
              />
            </div>
            <error-field :errors="errors" field="phone" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-3 pr-1">
            <div class="select-wrap">
              <label>Date of birth</label>
              <datepicker v-model="mover.date_of_birth"
                          name="date_of_birth"
                          placeholder="Select Date"
                          class="form-control"
                          :format="dateFormatter"
              />
            </div>
            <error-field :errors="errors" field="date_of_birth" />
          </div>
          <div class="col-3 pr-1">
            <div class="select-wrap amount-wrap">
              <label>Hourly wage</label>
              <span class="dollar">$</span>
              <input type="text"
                     class="form-control"
                     v-model="mover.wage"
              />
            </div>
            <error-field :errors="errors" field="wage" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-4 pr-1">
            <div class="select-wrap">
              <label>State</label>
              <simple-select v-if="states.length"
                             v-model="mover.state_id"
                             :options="states"
                             placeholder="Select State"
              />
            </div>
          </div>
          <div class="col-4 px-1">
            <div class="select-wrap">
              <label>City</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.city"
              />
            </div>
            <error-field :errors="errors" field="city" />
          </div>
          <div class="col-4 pl-1">
            <div class="select-wrap">
              <label>Zip</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.zip"
              />
            </div>
            <error-field :errors="errors" field="zip" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Address 1</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.address"
              />
            </div>
            <error-field :errors="errors" field="address" />
          </div>
          <div class="col-6 pl-1">
            <div class="select-wrap">
              <label>Address 2</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.address2"
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-3 pr-1">
            <div class="select-wrap">
              <label>Carrier</label>
              <simple-select v-model="mover.carrier_id"
                             v-if="carriers"
                             :options="carriers"
                             placeholder="Select Carrier"
              />
            </div>
            <error-field :errors="errors" field="carrier" />
          </div>
          <div class="col-2 px-1">
            <div class="select-wrap">
              <label>SSN</label>
              <input type="text"
                     class="form-control"
                     v-model="mover.ssn"
              />
            </div>
          </div>
          <div class="col-2 px-1">
            <div class="select-wrap">
              <label>SSN verified</label>
              <p class="px-3">
                <label class="switch-small">
                  <input type="checkbox"
                         v-model="mover.ssn_verified"
                  />
                  <span class="slider round" />
                </label>
              </p>
            </div>
          </div>
          <div class="col-2 pl-1">
            <div class="select-wrap">
              <label>Can this mover be a foreman?</label>
              <p class="px-3">
                <label class="switch-small">
                  <input type="checkbox"
                         v-model="mover.foreman"
                  />
                  <span class="slider round" />
                </label>
              </p>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-3 pr-1">
            <div class="select-wrap">
              <label>Timezone</label>
              <simple-select
                v-model="mover.timezone"
                :options="timezones"
                placeholder="Select time zone"
              />
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col">
            <button type="button"
                    class="btn btn-danger"
                    @click="remove(false)"
                    v-if="$_can('carriers.movers.destroy')"
            >
              Delete
            </button>
          </div>
          <div class="col">
            <button class="btn btn-primary float-right ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
                    v-if="$_can('carriers.movers.update')"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
      <movers-calendar />
    </div>

    <!-- Modal Assign Trucks -->
    <modal v-if="showDeleteModal"
           @close="showDeleteModal = false"
    >
      <div slot="header">
        <h4>This mover is assigned on following jobs:</h4>
      </div>
      <div class="scrollable" slot="body">
        <table class="table m-table table-hover log-table">
          <tbody>
            <tr v-for="job in assignedJobs"
                :key="job.id"
                @mouseup="($_can('jobs.update') || $_can('jobs.view-own')) && editJob($event, job.id)"
                class="pointer"
            >
              <td>{{ job.ref_id }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12">
            <button type="button" class="btn btn-danger pull-right ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
                    @click="remove(true)"
            >
              Force Delete
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Datepicker from 'vuejs-datepicker';
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import Date from '../../classes/Date';
import PhoneMask from '../../classes/PhoneMask';
import Modal from '../Modal';
import MoversCalendar from './MoversCalendar';

export default {
  name: 'MoverEditInfo',
  components: {
    MoversCalendar,
    Datepicker,
    ErrorField,
    Modal,
  },
  props: {
    mover: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    carrier: null,
    addresses: [],
    loadingButton: false,
    buttonDisabled: false,
    showDeleteModal: false,
    assignedJobs: [],
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      states: state => state.values.states,
      timezones: state => state.timezones.timezones.data,
    }),
  },
  mounted() {
    this.getTimezones();
    this.getStates();
  },
  methods: {
    ...mapActions(['getTimezones', 'getStates']),
    update() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      const moverId = this.$route.params.id;
      const mover = Object.assign({}, this.mover);
      axios
        .put(`movers/${moverId}`, { ...mover })
        .then(() => {
          toastr.success('Successfully updated mover');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.$emit('updated');
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    remove(force = false) {
      const moverId = this.$route.params.id;
      axios
        .delete(`movers/${moverId}${force ? '?force=true' : ''}`)
        .then(() => {
          this.$router.push('/movers');
          this.showDeleteModal = false;
          toastr.success('Successfully deleted mover');
        })
        .catch(err => {
          if (err.response.data.error.delete) {
            this.showDeleteModal = true;
            this.assignedJobs = JSON.parse(err.response.data.error.delete);
          }
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    dateFormatter(date) {
      this.mover.date_of_birth = Date.formattedDate(date);
      return this.mover.date_of_birth;
    },
    getAddressData: _.debounce(function call(streetName, index) {
      if (streetName.length < 3) {
        this.$set(this.showDropdown, index, false);
      } else {
        if (typeof this.source !== typeof undefined) {
          this.source.cancel('Operation canceled due to new request.');
        }
        this.source = axios.CancelToken.source();
        this.$set(this.showDropdown, index, true);
        axios
          .get(
            `autocomplete?address=${encodeURIComponent(streetName)}`,
            // cancel token used by axios
            { cancelToken: this.source.token },
          )
          .then(res => {
            this.$set(this.addresses, index, res.data.data);
          })
          .catch(err => {
            if (!axios.isCancel(err)) {
              this.errors.record(err.response.data.error);
            }
          });
      }
    }, 500),
    setAddress(address, index) {
      axios
        .get(
          `geocode?place_id=${encodeURIComponent(address.place_id)}&address=${encodeURIComponent(
            address.full_address,
          )}`,
        )
        .then(res => {
          let addressItem = address;
          [addressItem] = res.data.data;
          const addressNew = Object.assign({ type: this.mover.address.type }, addressItem);
          this.$set(this.mover, 'address', addressNew);
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
      this.mover.showDropdown[index] = false;
    },
    editJob(event, id) {
      if (event.button === 1) {
        window.open(
          this.$router.resolve(`/jobs/edit/${id}${this.q ? `?ref_id=${this.q}` : ''}`).href,
          '_blank',
        );
      }
      this.$router.push(`/jobs/edit/${id}${this.q ? `?ref_id=${this.q}` : ''}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/movers/MoversEditInfo.vue